import PropTypes from 'prop-types'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { toast } from 'react-toastify'

import ActionSubmittedModal from '../../Modal/ActionSubmittedModal'
import RosterLabels from '../RosterLabels'
import StudentRow from './StudentRow'
import * as eventActions from '../../../../actions/eventActions'
import { UncontrolledPopover } from 'reactstrap'
import colors from '../../../../assets/styles/globals.scss'
import styles from './EventRoster.module.scss'
import { ReactComponent as GolferIcon } from '../../../../assets/images/common/icons/golfer-half-icon.svg'

import classNames from 'classnames'
import Tooltip from '../../../common/Tooltip'
import SubmitButton from '../../../common/buttons/SubmitButton'

const EventRoster = ({ removeStudent }) => {
  const dispatch = useDispatch()
  const event = useSelector(state => state.nineHoleEvent)

  const [selectedStudent, setSelectedStudent] = useState(null)
  const [showSentReminderModal, setShowSentReminderModal] = useState(false)

  const CloseReminderModalButton = (
    <SubmitButton
      onClick={() => setShowSentReminderModal(false)}
      buttonMessage='Close'
      buttonColor='navy-button'
    />
  )

  const handleStudentMenuClick = (student) => {
    setSelectedStudent(student)
  }

  const sendRSVP = () => {
    dispatch(eventActions.sendEventReminder({ eventId: event.id, userId: selectedStudent.id })).unwrap()
      .then(() => setShowSentReminderModal(true))
      .catch(() => {
        toast.error(`The rsvp reminder for "${selectedStudent.firstName + ' ' + selectedStudent.lastName}" could not be sent.`,
          { position: toast.POSITION.BOTTOM_LEFT })
      })
  }

  const handleRSVPToggle = () => {
    dispatch(eventActions.updateRsvpStatus({ id: event.id, rsvpStatus: event.rsvpStatus }))
  }

  return (
    <div className='d-flex flex-column table-container'>
      <RosterLabels handleRSVPToggle={handleRSVPToggle}/>
      <div className={classNames('d-flex flex-column', styles.enrollmentsList)}>
        <Tooltip/>
        {event.students.length > 0 ?
          <table className='table animated fadeIn w-100'>
            <thead>
              <tr>
                <th className='golfer-header'>Golfer</th>
                <th className='px-5'>Age, Gender</th>
                <th>Program</th>
                <th>RSVP</th>
                <th>Pairing Status</th>
                <th>Note</th>
                <th className='centered-text'>Record Score</th>
                <th className='centered-text'>Level Attempts</th>
                <th className='px-5 centered-text'>{status !== 'completed' && 'Actions'}</th>
              </tr>
            </thead>
            <tbody>
              { event.students.map((std) =>
                <StudentRow key={std.id} std={std} handleStudentMenuClick={handleStudentMenuClick}/>
              )}

              <UncontrolledPopover
                placement='bottom'
                target='studentMenuButton'
                trigger='legacy'
              >
                <div className={classNames('d-flex flex-column', styles.studentActions)}>
                  <p aria-hidden='true' onClick={() => removeStudent(selectedStudent.enrollmentId)}>Remove Golfer</p>
                  <p aria-hidden='true' onClick={sendRSVP}>Send RSVP Reminder</p>
                </div>
              </UncontrolledPopover>
            </tbody>
          </table>
          :
          <div className={styles.noStudentsPlaceholder}>
            <GolferIcon id='golferIcon' fill={colors.lightNavy} width={'64px'} height={'64px'}/>
            <p className={styles.placeholderTitle}>No Students Enrolled</p>
            <div className={styles.placeholderDescription}>There are no enrollments for this event.</div>
          </div>
        }
      </div>
      <ActionSubmittedModal
        showModal={showSentReminderModal}
        closeModal={() => setShowSentReminderModal(false)}
        firstButton={CloseReminderModalButton}
        title='RSVP Reminder Sent!'
        icon={<i className='fa fa-envelope'/>}
      />
    </div>
  )
}

EventRoster.propTypes = {
  event: PropTypes.shape({
    id: PropTypes.number,
    students: PropTypes.array,
    status: PropTypes.string,
    rsvpStatus: PropTypes.string,
  }),
  removeStudent: PropTypes.func.isRequired,
}

export default EventRoster
